const meta = {
  analyzer: 'Live Telemetry Analyzer',
  usage: 'Telemetry Usage Analyzer',
  troubleshooting: 'Troubleshooting',
  dictionary: 'Dictionary',
};

export default meta;
